export function formatPrice(cents) {
  return (cents / 100).toLocaleString('EUR', {
    style: 'currency',
    currency: 'EUR',
  })
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
export function capitalize(string) {
  if (process.env.NODE_ENV !== 'production' && typeof string !== 'string') {
    throw new Error(
      'Material-UI: capitalize(string) expects a string argument.'
    )
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}

// Filter an object
// const cashedOutBets = filterObject(history, 'result', 'cashed-out')
export function filterObject(obj, filter, filterValue) {
  return Object.keys(obj).reduce(
    (acc, val) =>
      obj[val][filter] === filterValue
        ? acc
        : {
            ...acc,
            [val]: obj[val],
          },
    {}
  )
}
